// extracted by mini-css-extract-plugin
module.exports = {"recommendations-product-quantity":"RecommendationProductQuantity_recommendations-product-quantity__FLloB"};